export default __webpack_public_path__ + "static/Tek_Boots-c5d5a1febe5067c42f0e911a1d89ab59.png";